var Theme;

jQuery(document).ready(function(){

	Theme = {

		/**
		 * Init
		 */
		init:function(){

			// Cache elements
			Theme.w = jQuery(window);
			Theme.html = jQuery('html');
			Theme.body = jQuery('body');
			Theme.toggleNavButton = jQuery('.toggle-nav');
			Theme.toggleSubNavButton = jQuery('.nav-main .menu-item-has-children > a');
			Theme.slider = jQuery('.slider');
			Theme.sliderLength = Theme.slider.find('.slide').length;

			Theme.mobileWidth = 782;

			// Go!
			Theme.bindings();

		},

		bindings:function(){

			// Lightbox
			jQuery('.gallery a').attr('rel','Galerie');
			jQuery('a[href$=".jpg"],a[href$=".jepg"],a[href$=".png"]').fancybox();

			// Toggle nav
			Theme.toggleNavButton.click(function(e){
				e.preventDefault();
				Theme.toggleNav();
			});

			Theme.toggleSubNavButton.click(function(e){
				if ( Theme.mobileWidth < Theme.w.width() )
					return;

				e.preventDefault();
				jQuery(this).parent().find('.sub-menu').slideToggle();
			});

			// Slider
			if ( 1 < Theme.sliderLength )
				Theme.slider.bxSlider({
					mode: 'fade'
				});

		},

		submitForm:function( form, options ) {

			if ( Theme.validateForm( form ) && ( undefined === options || undefined === options.validate || ( options && typeof options.validate === 'function' && true === options.validate() ) ) ) {

				if ( options && typeof options.before === 'function' )
					options.before();

				form.addClass('submitting');
				var button = form.find('button[type=submit]').addClass('loading');
				var data = form.serialize();

				jQuery.post( ajaxurl, data, function(response){

					button.removeClass('loading');

					if ( undefined !== options && false !== options.empty ) {
						form.find('input[type="text"],textarea,select').val('');
						form.find('input[type="radio"], input[type="checkbox"]').removeAttr('checked');
					}

					if ( options && typeof options.response === 'function' )
						options.response(form,response);
					else
						form.before(response);

					if ( options && typeof options.after === 'function' )
						options.after(response);

					form.removeClass('submitting');

				});

			}

		},

		toggleNav:function(){

			Theme.body.toggleClass( 'nav-visible' );

		},

		validateForm:function( form ){

			if ( form.hasClass('submitting') )
				return false;

			// Remove old validation
			jQuery('.error-input').removeClass('error-input');
			form.find('.message').remove();

			// Cache
			var submit = true,
				requiredFields = form.find('input.required, textarea.required');

			// Validate the fields
			requiredFields.each(function(){
				var obj = jQuery(this);
				if ( '' === obj.val() ) {
					obj.addClass( 'error-input' );
					submit = false;
				}
			});

			return submit;
		}

	};

	Theme.init();

});
